// eslint-disable-next-line
export const SET_LOGIN_ERROR_MESSAGE = 'form/set-login-error-message';
